<div class="flex-container">
  <div class="flex-item">{{ userProcessData.actions }}</div>
  <div class="vertical-line"></div>
  <div class="flex-item">{{ userProcessData.tooltip }}</div>
  <div class="vertical-line"></div>
  <div class="flex-item">{{ userProcessData.KayitKullaniciKod }}</div>
  <div class="vertical-line"></div>
  <div class="flex-item">
    {{ userProcessData.KayitTarih | date : 'MM/dd/yyyy hh:mm' }}
  </div>
  <div class="vertical-line"></div>
  <div class="flex-item">{{ userProcessData.DegisKullaniciKod }}</div>
  <div class="vertical-line"></div>
  <div class="flex-item">
    {{ userProcessData.DegisTarih | date : 'MM/dd/yyyy hh:mm' }}
  </div>
</div>
